import JWT_DOMAIN from '../../constants/domain'

const getJwtSelect = state => state?.[JWT_DOMAIN]

export default getJwtSelect
